module.exports = __webpack_public_path__ + "img/Calendar-Light.03df61bb.svg";